/** @format */

import React, { memo } from 'react'

import * as courses from 'dir'

export const Page = memo(({ module, history, match: { params } }) => {
  const currentType = Object.keys(params)[0]
  const currentCourse = courses[currentType]
  const currentLesson = currentCourse?.['_' + module]
  const CurrentStep = currentLesson?.['_' + params[currentType]]

  if (CurrentStep) {
    return (
      <div>
        <CurrentStep />
      </div>
    )
  }

  history.push('/')
  return null
})
